module.exports = __webpack_public_path__ + "7ba2bee79ba2937ea0f4a1dfae7913e1.jpg";